import { Link, usePage } from '@inertiajs/react';
import {
  Box,
  Button,
  CloseButton,
  Container,
  Divider,
  Grid,
  GridCol,
  Group,
  Image,
  Overlay,
  rem,
  Stack,
  Text,
  useMantineTheme,
} from '@mantine/core';
import { Modal, ScrollArea } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useDisclosure } from '@mantine/hooks';
import { IconArrowRight, IconChevronRight } from '@tabler/icons-react';

import logo from '@/images/logo-white.svg';
import SocialBrands from '@/pages/site/layouts/SocialBrands.jsx';

// import SocialBrands from '@/pages/site/layouts/SocialBrands.jsx';
import MacellanLogo from './macellan-logo.svg';

function FooterNav() {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  return (
    <Group w={'100%'} grow align={'flex-start'} gap={isMobile ? 5 : 50}>
      <Stack gap={'lg'} pt={'lg'}>
        <Stack gap={15} align={'stretch'}>
          <Text fz={rem(18)} c="white" fw={'600'}>
            Şirket
          </Text>
          <Divider />
        </Stack>
        <Link href={route('site.about')}>
          <Text fz={rem(16)} c="white">
            Hakkımızda
          </Text>
        </Link>
      </Stack>
      <Stack gap={'lg'} pt={'lg'}>
        <Stack gap={15} align={'stretch'}>
          <Text fz={rem(18)} c="white" fw={'600'}>
            Öğren
          </Text>
          <Divider />
        </Stack>
        <Link href={route('site.how-it-works')}>
          <Text fz={rem(16)} c="white">
            Nasıl Çalışır
          </Text>
        </Link>
        <Link href={route('site.faq')}>
          <Text fz={rem(16)} c="white">
            Sık Sorulan Sorular
          </Text>
        </Link>
      </Stack>
      <Stack gap={'lg'} pt={'lg'}>
        <Stack gap={15} align={'stretch'}>
          <Text fz={rem(18)} c="white" fw={'600'}>
            Yasal
          </Text>
          <Divider />
        </Stack>
        <Link href={route('site.legal.terms')}>
          <Text fz={rem(16)} c="white">
            Kullanıcı Sözleşmesi
          </Text>
        </Link>
        <Link href={route('site.legal.privacy-policy')}>
          <Text fz={rem(16)} c="white">
            KVKK
          </Text>
        </Link>
        <Link href={route('site.legal.risk-warning')}>
          <Text fz={rem(16)} c="white">
            Yasal Uyarı
          </Text>
        </Link>
      </Stack>
    </Group>
  );
}

function Copyright({ ...props }) {
  return (
    <Stack {...props}>
      <Group>
        <SocialBrands color={'white'} />
      </Group>
      <Text mt={0} c="white">
        © {new Date().getFullYear()} Hisselitapu. Her hakkı saklıdır.
      </Text>
    </Stack>
  );
}

function Disclaimer() {
  const [opened, { open, close }] = useDisclosure(false);

  const firstParagraph =
    'Hisselitapu does not provide any financial advice. None of the information that Hisselitapu provides on the Hisselitapu Platform or the websites should be regarded as "investment advice" or "recommendation" regarding a course of action, including without limitation, as those terms are used in any applicable law or regulations.';

  return (
    <Box style={{ position: 'relative', width: '100%' }} bg={'#030356'} c={'white'}>
      <Modal size={'xl'} opened={opened} onClose={close} title="Important Disclaimers" scrollAreaComponent={ScrollArea.Autosize}>
        <p>{firstParagraph}</p>
        {opened && (
          <>
            <p>
              Hisselitapu does not purport to and does not, in any fashion, provide tax, accounting, actuarial, recordkeeping,
              legal, broker/dealer or any related services. You should consult your own advisors with respect to these areas and
              any material with regards to investment decisions. You may not rely on the material contained herein. Hisselitapu
              shall not have any liability for any damages of any kind whatsoever relating to this material.
            </p>
            <p>
              Hisselitapu is not a financial institution and is not licensed by or under the supervision of any financial
              supervisory authority and does not provide any licensed financial services such as investment services, capital
              raising, fund management, management of a collective investment scheme or investment advice.
            </p>
            <p>
              The website is provided "as is" and on an "as available" basis and we give no warranty that it will be free from
              defects and/or faults. We make no warranty or representation (express or implied) that it will be fit for any
              particular purposes, that it will not infringe the rights of third parties, that it will be compatible with all
              systems, that it will be secure or that all information provided will be continuous, uninterrupted, timely, accurate
              or error-free. Hisselitapu reserves the right to change any and all content on the Hisselitapu Platform and on the
              websites and any services offered at any time without notice. Reference to any products, services, processes or
              other information by trademark, manufacturer, supplier or otherwise does not constitute or imply endorsement,
              sponsorship or recommendation thereof, or any affiliation with Hisselitapu (unless so expressly stated to be so).
            </p>
            <p>
              The Hisselitapu Platform and the websites may be temporarily unavailable from time to time for maintenance or other
              reasons. We assume no responsibility for any error, omission, interruption, deletion, defect, delay in operation or
              transmission, communications line failure, theft or destruction or unauthorised access to, or alteration of your
              communication.
            </p>
            <p>
              There are no platform tokens associated with the Hisselitapu. The tokens are not intended to be used as a means of
              payment or similar.
            </p>
            <p>
              Nothing on this website should be construed as an offer to sell, solicitation of an offer to buy or a recommendation
              in respect of a security. You are solely responsible for determining whether any investment, investment strategy or
              related transaction is appropriate for you based on your personal investment objectives, financial circumstances and
              risk tolerance. You should consult with licensed legal professionals and investment advisors for any legal, tax,
              insurance or investment advice.
            </p>
            <p>
              No information published on the Hisselitapu Website constitutes a solicitation or offer, or recommendation, to buy
              or sell any digital assets, investment instruments, to effect any transactions, or to conclude any legal act of any
              kind whatsoever.
            </p>
            <p>
              <b>Forward-looking statements</b>
            </p>
            <p>
              This Website may contain forward looking statements and may be subject to change. The opinions expressed herein are
              those of Hisselitapu, its affiliates and partners at the time of writing. The information and analyses contained in
              this Website, such as for example financial market data, market prices and any other financial market information,
              are based upon or by reference to carefully selected sources which are believed to be reliable. However, Hisselitapu
              makes no representation as to its reliability or completeness and disclaims all liability for losses arising from
              the use of this information. Past performance is not an indication or guarantee of future performance of a product
              or underlying asset. The value of any investment may be subject to fluctuations and, in some circumstances,
              investors may not recover the original amount invested. Exchange rate fluctuations may also cause the value of an
              investment to rise or fall. No information published on the Hisselitapu Website should therefore be understood as an
              indication of the future development of any financial instrument, cryptocurrency, digital asset, security or
              whatsoever.
            </p>
          </>
        )}
      </Modal>

      <Container style={{ width: '100%' }} my={'md'}>
        <Box c={'white'}>
          <Text fz={rem(16)}>Important Disclaimers</Text>
          <Text mt={5} fz={rem(14)}>
            {firstParagraph}
          </Text>
          <Text mt={5} mb={5} onClick={open} fz={rem(14)} style={{ cursor: 'pointer', zIndex: 200 }}>
            Read More
          </Text>
        </Box>
      </Container>
    </Box>
  );
}

export default function SiteFooter(props) {
  // mantine way is mobile check
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

  return (
    <Stack mih={'var(--footer-height)'} bg={'navy.8'} c={'white'} {...props} align={'stretch'} justify="flex-end" pt={30}>
      {/*<BottomAlert />*/}

      <Container style={{ width: '100%' }} pb={10}>
        <Grid gutter={'xl'} justify="space-between">
          <GridCol span="auto">
            <FooterNav />
          </GridCol>
          <GridCol span={{ base: 12, md: 'content' }}>
            <Box bg={'rgba(0,0,0,0.2)'} miw={300}>
              <Stack align={'stretch'} justify={'flex-start'} px={'xl'} py={'lg'} gap={'md'}>
                <Text fw={'600'} fz={rem(18)}>
                  Bize Ulaşın
                </Text>
                <Divider />
                <Link href={'#'}>
                  <Group style={{ display: 'flex', justifyContent: 'space-between' }} pl={0} pr={0}>
                    <Text fw={'400'} fz={rem(16)}>
                      Tüm Makalelerimiz
                    </Text>
                    <IconChevronRight stroke={1} />
                  </Group>
                </Link>
                <Link href={'#'}>
                  <Group style={{ display: 'flex', justifyContent: 'space-between' }} pl={0} pr={0}>
                    <Text fw={'400'} fz={rem(16)}>
                      Haberler
                    </Text>
                    <IconChevronRight stroke={1} />
                  </Group>
                </Link>
                <Group justify={'space-between'}>
                  <SocialBrands color={'white'} />
                </Group>
              </Stack>
            </Box>

            <Box bg={'rgba(0,0,0,0.2)'} miw={300} mt={'md'} px={'xl'} py={'md'}>
              <Text fz={rem(14)}>
                Bir{' '}
                <a href="https://macellan.net" target="_blank" rel="follow noreferrer">
                  <Image style={{ display: 'inline' }} src={MacellanLogo} h={10} w={'auto'} px={5} />
                </a>{' '}
                girişimidir.
              </Text>
            </Box>
          </GridCol>
        </Grid>
      </Container>
      <Disclaimer />
    </Stack>
  );
}

// function BottomAlert() {
//   const [opened, handlers] = useDisclosure(true);
//   const user = usePage().props?.auth?.user;
//
//   if (user) {
//     return null;
//   }
//
//   if (!opened) {
//     return null;
//   }
//
//   return (
//     <Box
//       bg={'gf.2'}
//       style={{ borderTop: '2px solid var(--mantine-color-gf-3)', position: 'sticky', bottom: 0, zIndex: 1 }}
//       py={'xs'}
//     >
//       <Container>
//         <Group justify={'space-between'} align={'center'}>
//           <Text fz={'sm'} fw={'bold'} c={'gfdark.9'}>
//             <a href={route('register')}>Sign up now and get a $10 free gift coupon!</a>
//           </Text>
//           <CloseButton onClick={handlers.close} variant="transparent" size={'sm'} />
//         </Group>
//       </Container>
//     </Box>
//   );
// }
